import type { PermissionGroup, RolePermission } from '../types/roles.types';

export function groupPermissionsByResource(permissions: RolePermission[]): PermissionGroup[] {
  const byResource = new Map<string, RolePermission[]>();

  for (const permission of permissions) {
    const existing = byResource.get(permission.resource);
    if (existing) {
      existing.push(permission);
    } else {
      byResource.set(permission.resource, [permission]);
    }
  }

  return Array.from(byResource.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([resource, resourcePermissions]) => ({
      resource,
      permissions: [...resourcePermissions].sort((a, b) => a.action.localeCompare(b.action)),
    }));
}
